/* KNOWOL shop homepage (sections/kw-home.liquid), Claude for Max 10/16/26.
   1. Town search: same two Shopify searches as the product page box (snippets/knowol-pdp-v2.liquid): the instant one
      (search/suggest.json) and the full one (templates/search.kw-json.liquid, better at partial words). Town maps first,
      then up to two restored vintage maps. Nothing loads until someone types. No match = "ask us to draw it".
   2. Magnifier on the Bellaire print: the 2400 px picture loads only when the section comes near the screen.
      Mouse: the lens follows the pointer. Touch: a tap moves the lens there (the page still scrolls normally).
   3. Sections below the fold rise in gently (off for reduced motion).
   ASCII only in this file. */
(function () {
  'use strict';
  var d = document, html = d.documentElement;
  var RM = window.matchMedia('(prefers-reduced-motion: reduce)');
  var FINE = window.matchMedia('(hover: hover) and (pointer: fine)');

  /* ---------- 1. search ---------- */
  function initFind() {
    var box = d.getElementById('kwh-find');
    if (!box) return;
    var input = box.querySelector('.kwh-find__input'), list = box.querySelector('.kwh-find__list');
    var clear = box.querySelector('.kwh-find__clear'), status = box.querySelector('[data-kwh-status]');
    var requestUrl = box.getAttribute('data-request') || '';
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var cache = {}, timer = 0, active = -1, lastQ = '';
    var money = (function () {
      try { var f = new Intl.NumberFormat('en-US', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD' }); return function (v) { return f.format(+v); }; }
      catch (e) { return function (v) { return '$' + (+v).toFixed(2); }; }
    })();
    function esc(t) { return String(t).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
    function mark(text, q) {
      var lt = text.toLowerCase(), cand = [q.trim(), q.trim().split(/\s+/)[0]], i = -1, m = '';
      for (var c = 0; c < cand.length && i < 0; c++) { m = cand[c]; i = m ? lt.indexOf(m.toLowerCase()) : -1; }
      return i < 0 ? esc(text) : esc(text.slice(0, i)) + '<b>' + esc(text.slice(i, i + m.length)) + '</b>' + esc(text.slice(i + m.length));
    }
    function opts() { return [].slice.call(list.querySelectorAll('[role="option"]')); }
    function setActive(i) {
      var o = opts(); active = i;
      o.forEach(function (el, k) { el.classList.toggle('is-active', k === i); el.setAttribute('aria-selected', k === i ? 'true' : 'false'); });
      if (i >= 0 && o[i]) { input.setAttribute('aria-activedescendant', o[i].id); o[i].scrollIntoView({ block: 'nearest' }); }
      else input.removeAttribute('aria-activedescendant');
    }
    function open() { list.hidden = false; box.classList.add('is-open'); input.setAttribute('aria-expanded', 'true'); }
    function close() { list.hidden = true; box.classList.remove('is-open'); input.setAttribute('aria-expanded', 'false'); setActive(-1); }
    function norm(t) {
      var n = ' ' + String(t).toLowerCase().replace(/&/g, ' and ').replace(/[^a-z0-9 ]+/g, ' ').replace(/\s+/g, ' ').trim() + ' ';
      return n.replace(/ st (?=\S)/g, ' saint ').replace(/ mt (?=\S)/g, ' mount ').replace(/ ft (?=\S)/g, ' fort ');
    }
    function variants(q) {
      var n = ' ' + q.toLowerCase().replace(/\s+/g, ' ').trim() + ' ', out = [q], pairs = [['saint', 'st.'], ['mount', 'mt.'], ['fort', 'ft.']];
      pairs.forEach(function (pr) {
        var a = new RegExp(' ' + pr[0] + ' '), b = new RegExp(' ' + pr[1].replace('.', '\\.?') + ' ');
        if (a.test(n)) out.push(n.replace(a, ' ' + pr[1] + ' ').trim());
        else if (b.test(n)) out.push(n.replace(b, ' ' + pr[0] + ' ').trim());
      });
      return out.slice(0, 2);
    }
    var TOWN = /\sMap\s+(Art|Print)\s*$/i;
    /* "Springfield, IL" or "Springfield, Illinois": that state's town goes first */
    var ST = 'al alabama ak alaska az arizona ar arkansas ca california co colorado ct connecticut de delaware fl florida ga georgia hi hawaii id idaho il illinois in indiana ia iowa ks kansas ky kentucky la louisiana me maine md maryland ma massachusetts mi michigan mn minnesota ms mississippi mo missouri mt montana ne nebraska nv nevada nh new_hampshire nj new_jersey nm new_mexico ny new_york nc north_carolina nd north_dakota oh ohio ok oklahoma or oregon pa pennsylvania ri rhode_island sc south_carolina sd south_dakota tn tennessee tx texas ut utah vt vermont va virginia wa washington wv west_virginia wi wisconsin wy wyoming pr puerto_rico gu guam vi virgin_islands as american_samoa mp northern_mariana_islands'.split(' ');
    var ABBR = {}; for (var si = 0; si < ST.length; si += 2) ABBR[ST[si]] = ST[si + 1].replace(/_/g, ' ');
    function wantState(q) {
      var c = q.split(','); if (c.length < 2) return '';
      var s = norm(c[1]).trim(); if (!s) return '';
      if (ABBR[s.replace(/ /g, '')]) return ABBR[s.replace(/ /g, '')];
      for (var k in ABBR) { if (ABBR[k].indexOf(s) === 0) return ABBR[k]; }
      return '';
    }
    /* "Franklin TN" / "Franklin Tennessee" (no comma): a state at the end. Only a hint: the whole query is still
       searched and still ranks first, so "Mount Washington" keeps finding Mount Washington. */
    function tailState(q) {
      if (q.indexOf(',') >= 0) return null;
      var n = norm(q).trim(), w = n.split(' ');
      if (w.length > 1 && ABBR[w[w.length - 1]]) return { town: w.slice(0, -1).join(' '), state: ABBR[w[w.length - 1]] };
      for (var k in ABBR) {
        var full = ABBR[k];
        if (n.length > full.length + 1 && n.slice(-(full.length + 1)) === ' ' + full) return { town: n.slice(0, -(full.length + 1)).trim(), state: full };
      }
      return null;
    }
    function isVintage(t) { return /\b1[6-9]\d\d\b/.test(t) && /map|view/i.test(t); }
    function rank(q, arr) {
      var nq = norm(q.split(',')[0]).trim(), seen = {}, towns = [], old = [], want = wantState(q), tail = tailState(q);
      var words = norm(want ? q.split(',')[0] : q).trim().split(' ');
      (arr || []).forEach(function (x, k) {
        if (!x || !x.u || seen[x.h]) return;
        seen[x.h] = 1;
        var title = String(x.t);
        if (TOWN.test(title)) {
          var t = title.replace(TOWN, ''), nt = norm(t), town = norm(t.split(', ')[0]);
          var score = (town.indexOf(' ' + nq) === 0 || nt.indexOf(' ' + nq) === 0) ? 0
            : words.every(function (w) { return nt.indexOf(' ' + w) >= 0; }) ? 1 : 2;
          var stTxt = norm(t.split(', ').slice(1).join(' '));
          if (want && score < 2 && stTxt.indexOf(' ' + want + ' ') >= 0) score -= 0.5;
          if (score === 2 && tail && tail.town && town.indexOf(' ' + tail.town) === 0 && stTxt.indexOf(' ' + tail.state + ' ') >= 0) score = 0.5;
          towns.push({ x: x, s: score, k: k, kind: 'town' });
        } else if (isVintage(title)) {
          var nv = norm(title);
          if (words.every(function (w) { return nv.indexOf(' ' + w) >= 0; })) old.push({ x: x, s: 0, k: k, kind: 'old' });
        }
      });
      towns.sort(function (a, b) { return a.s - b.s || a.k - b.k; });
      var good = towns.filter(function (o) { return o.s < 2; }).length;
      /* one real match is enough to drop the fuzzy ones ("pensacola" used to add Pebble Creek and Poinciana) */
      if (good >= 1) towns = towns.filter(function (o) { return o.s < 2; });
      else towns = towns.slice(0, 4);
      var out = towns.slice(0, 6).concat(old.slice(0, 2));
      out.good = good + Math.min(old.length, 2);
      return out;
    }
    function fromSuggest(j) {
      return ((((j || {}).resources || {}).results || {}).products || []).map(function (x) {
        return { h: x.handle, t: x.title, u: x.url, p: x.price_min ? money(x.price_min) : '',
          i: x.image ? x.image + (x.image.indexOf('?') < 0 ? '?' : '&') + 'width=104&height=104&crop=center' : null };
      });
    }
    function getJSON(u) { return fetch(u, { headers: { Accept: 'application/json' } }).then(function (r) { if (!r.ok) throw r.status; return r.text(); }).then(function (t) { return JSON.parse(t); }); }
    function full(v) { return getJSON(root + 'search?q=' + encodeURIComponent(v) + '&type=product&options%5Bprefix%5D=last&options%5Bfields%5D=title&view=kw-json'); }
    function quick(v) { return getJSON(root + 'search/suggest.json?q=' + encodeURIComponent(v) + '&resources%5Btype%5D=product&resources%5Blimit%5D=10&resources%5Boptions%5D%5Bfields%5D=title&resources%5Boptions%5D%5Bunavailable_products%5D=hide').then(fromSuggest); }
    function requestLink(q) {
      if (!requestUrl) return '';
      var parts = q.split(','), city = parts[0].trim(), st = (parts[1] || '').trim();
      return requestUrl + '?requested-city=' + encodeURIComponent(city) + (st ? '&requested-state=' + encodeURIComponent(st) : '');
    }
    function render(q, ranked) {
      var h = '';
      ranked.forEach(function (o, k) {
        var x = o.x, title = String(x.t), main, sub;
        if (o.kind === 'town') {
          var t = title.replace(TOWN, ''), cut = t.indexOf(', ');
          main = mark(cut > 0 ? t.slice(0, cut) : t, q.split(',')[0]); sub = esc(cut > 0 ? t.slice(cut + 2) : '');
        } else {
          main = mark(title.split(' | ')[0].replace(/^Vintage Map of /i, ''), q.split(',')[0]); sub = 'Restored vintage map';
        }
        h += '<li class="kwh-find__opt" role="option" id="kwh-opt-' + k + '" aria-selected="false"><a href="' + esc(x.u) + '" tabindex="-1">' +
          '<span class="kwh-find__thumb"' + (x.i ? ' style="background-image:url(&quot;' + esc(x.i) + '&quot;)"' : '') + '></span>' +
          '<span class="kwh-find__name">' + main + '<span class="kwh-find__state">' + sub + '</span></span>' +
          (x.p ? '<span class="kwh-find__price">from ' + esc(x.p) + '</span>' : '') + '</a></li>';
      });
      if (!ranked.length) {
        var rl = requestLink(q);
        h += '<li class="kwh-find__none">We haven&rsquo;t drawn &ldquo;' + esc(q) + '&rdquo; yet. Check the spelling, or ' +
          (rl ? '<a href="' + esc(rl) + '">ask us to draw it</a>.' : 'try the county or state.') + '</li>';
        if (window.gtag) { try { gtag('event', 'home_search_none', { search_term: q }); } catch (e) {} }
      }
      h += '<li class="kwh-find__all" role="option" id="kwh-opt-all" aria-selected="false"><a href="' + esc(root + 'search?q=' + encodeURIComponent(q) + '&type=product&options%5Bprefix%5D=last') + '" tabindex="-1">See all results for &ldquo;' + esc(q) + '&rdquo; <span aria-hidden="true">&rarr;</span></a></li>';
      var keep = active >= 0 && opts()[active] ? (opts()[active].querySelector('a') || {}).href : null;
      list.innerHTML = h; active = -1; open();
      if (keep) { var o2 = opts(); for (var i = 0; i < o2.length; i++) { if ((o2[i].querySelector('a') || {}).href === keep) { setActive(i); break; } } }
      status.textContent = ranked.length ? ranked.length + (ranked.length === 1 ? ' map found' : ' maps found') : 'No maps found';
    }
    function search(raw) {
      var q = raw.trim(); lastQ = q;
      if (q.length < 2) { close(); status.textContent = ''; return; }
      var key = norm(q);
      if (cache[key]) { render(q, cache[key]); return; }
      box.classList.add('is-busy');
      var ts = tailState(q);
      var settled = false, shownQuick = false, vs = ts && ts.town ? [ts.town, q] : variants(q.split(',')[0].trim() || q);
      var fullP = Promise.all(vs.map(function (v) { return full(v).catch(function () { return null; }); }))
        .then(function (lists) {
          if (lists.every(function (l) { return !l; })) throw 'full search failed';
          var merged = []; lists.forEach(function (l) { if (l) merged = merged.concat(l); });
          return rank(q, merged);
        });
      var quickP = Promise.all(vs.map(function (v) { return quick(v).catch(function () { return []; }); }))
        .then(function (lists) { return rank(q, [].concat.apply([], lists)); });
      quickP.then(function (r) { if (!settled && q === lastQ && r.good >= 3) { shownQuick = true; render(q, r); } });
      var late = setTimeout(function () { quickP.then(function (r) { if (!settled && q === lastQ && !shownQuick) { shownQuick = true; render(q, r); } }); }, 900);
      fullP.then(function (r) { settled = true; clearTimeout(late); cache[key] = r; if (q === lastQ) render(q, r); })
        .catch(function () { clearTimeout(late); quickP.then(function (r) { settled = true; cache[key] = r; if (q === lastQ) render(q, r); }); })
        .then(function () { if (q === lastQ) box.classList.remove('is-busy'); });
    }
    input.addEventListener('input', function () {
      box.classList.toggle('has-text', !!input.value);
      clearTimeout(timer); timer = setTimeout(function () { search(input.value); }, 110);
    });
    input.addEventListener('keydown', function (e) {
      var o = opts();
      if (e.key === 'ArrowDown') { e.preventDefault(); if (list.hidden) { search(input.value); return; } setActive(active + 1 >= o.length ? 0 : active + 1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); if (!list.hidden) setActive(active - 1 < 0 ? o.length - 1 : active - 1); }
      else if (e.key === 'Enter') { if (active >= 0 && o[active]) { e.preventDefault(); location.href = o[active].querySelector('a').href; } }
      else if (e.key === 'Escape') { if (!list.hidden) { e.preventDefault(); close(); } else if (input.value) { input.value = ''; box.classList.remove('has-text'); } }
    });
    input.addEventListener('focus', function () {
      if (input.value.trim().length >= 2) search(input.value);
      if (!FINE.matches && window.innerWidth < 750) {
        setTimeout(function () { var r = box.getBoundingClientRect(); window.scrollTo({ top: r.top + window.pageYOffset - 84, behavior: RM.matches ? 'auto' : 'smooth' }); }, 280);
      }
    });
    box.querySelector('form').addEventListener('submit', function (e) { if (!input.value.trim()) { e.preventDefault(); input.focus(); } });
    clear.addEventListener('click', function () { input.value = ''; box.classList.remove('has-text'); close(); status.textContent = ''; input.focus(); });
    list.addEventListener('mousemove', function (e) { var li = e.target.closest('[role="option"]'); if (li) { var k = opts().indexOf(li); if (k !== active) setActive(k); } });
    d.addEventListener('pointerdown', function (e) { if (!box.contains(e.target)) close(); });
    if (/[?&]kwq=/.test(location.search)) {
      var m = location.search.match(/[?&]kwq=([^&]*)/);
      try { input.value = decodeURIComponent(m[1].replace(/\+/g, ' ')); box.classList.add('has-text'); search(input.value); } catch (e) {}
    }
  }

  /* ---------- 2. magnifier ---------- */
  function initLoupe() {
    var fig = d.querySelector('.kwh-loupe');
    if (!fig) return;
    var lens = fig.querySelector('.kwh-loupe__lens'), url = fig.getAttribute('data-zoom');
    var restX = parseFloat(fig.getAttribute('data-rest-x')) || 0.5, restY = parseFloat(fig.getAttribute('data-rest-y')) || 0.5;
    var loaded = false, M = 3.4, raf = 0, pending = null;
    function size() { return fig.getBoundingClientRect(); }
    function put(fx, fy) {
      var r = size(), L = lens.offsetWidth || 200, W = r.width, H = r.height, m = FINE.matches ? M : 2.8;
      fx = Math.max(0, Math.min(1, fx)); fy = Math.max(0, Math.min(1, fy));
      lens.style.left = (fx * W) + 'px'; lens.style.top = (fy * H) + 'px';
      lens.style.backgroundSize = (W * m) + 'px ' + (H * m) + 'px';
      lens.style.backgroundPosition = (L / 2 - fx * W * m) + 'px ' + (L / 2 - fy * H * m) + 'px';
    }
    function rest(glide) {
      fig.classList.toggle('is-glide', !!glide);
      put(restX, restY);
    }
    function load() {
      if (loaded) return; loaded = true;
      var im = new Image();
      im.onload = function () {
        lens.style.backgroundImage = 'url("' + url + '")';
        fig.classList.add('is-ready');
        rest(false);
        setTimeout(function () { fig.classList.add('is-on'); }, 60);
      };
      im.src = url;
    }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { load(); io.disconnect(); } }); }, { rootMargin: '500px 0px' });
      io.observe(fig);
    } else load();
    fig.addEventListener('pointermove', function (e) {
      if (e.pointerType !== 'mouse' || !loaded) return;
      var r = size(); pending = [(e.clientX - r.left) / r.width, (e.clientY - r.top) / r.height];
      fig.classList.remove('is-glide');
      if (!raf) raf = requestAnimationFrame(function () { raf = 0; if (pending) put(pending[0], pending[1]); });
    });
    fig.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse' && loaded) rest(!RM.matches); });
    fig.addEventListener('click', function (e) {
      if (!loaded) { load(); return; }
      if (FINE.matches) return;
      var r = size(); fig.classList.toggle('is-glide', !RM.matches);
      put((e.clientX - r.left) / r.width, (e.clientY - r.top) / r.height);
    });
    window.addEventListener('resize', function () { if (loaded) rest(false); });
  }

  /* ---------- 3. rise in ---------- */
  function initRise() {
    if (RM.matches || !('IntersectionObserver' in window)) return;
    var els = [].slice.call(d.querySelectorAll('.kwh-band .kwh-head, .kwh-band .kwh-cards, .kwh-detail__grid, .kwh-sizes__grid, .kwh-stgrid, .kwh-states__more, .kwh-also'));
    var vh = window.innerHeight;
    els = els.filter(function (el) { return el.getBoundingClientRect().top > vh * 0.9; });
    els.forEach(function (el) { el.classList.add('kwh-rise'); });
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- 4. second photo on card hover ----------
     Only for a mouse. They load quietly once the page is done (or on the first hover), so phones never download them. */
  function initHoverPhotos() {
    if (!FINE.matches) return;
    var imgs = [].slice.call(d.querySelectorAll('.kwh-card__img--alt[data-srcset]'));
    if (!imgs.length) return;
    function load(im) {
      if (!im.hasAttribute('data-srcset')) return;
      im.addEventListener('load', function () { im.classList.add('is-loaded'); }, { once: true });
      im.srcset = im.getAttribute('data-srcset'); im.removeAttribute('data-srcset');
    }
    imgs.forEach(function (im) {
      var a = im.closest('.kwh-card__link');
      if (a) a.addEventListener('pointerenter', function () { load(im); }, { once: true });
    });
    function all() { imgs.forEach(load); }
    function later() { (window.requestIdleCallback || function (f) { setTimeout(f, 200); })(all); }
    if (d.readyState === 'complete') setTimeout(later, 1500);
    else window.addEventListener('load', function () { setTimeout(later, 1500); });
  }

  function start() { initFind(); initLoupe(); initRise(); initHoverPhotos(); }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', start); else start();
})();
